import api from './api';
import { CategoriaSaidaCaixa } from '../types';

export type RecurringCashMovementFrequency = 'monthly';
export type RecurringCashMovementStatus = 'active' | 'paused' | 'finished';

export interface RecurringCashMovement {
  id: number;
  company_id?: number;
  type: 'saida';
  category: CategoriaSaidaCaixa;
  description: string;
  amount: number;
  payable_note?: string | null;
  frequency: RecurringCashMovementFrequency;
  start_date: string; // YYYY-MM-DD
  end_date?: string | null; // YYYY-MM-DD (mensal com fim)
  installments_total?: number | null; // parcelas N
  status: RecurringCashMovementStatus;
  created_at?: string;
  updated_at?: string;
}

type ApiRecurringCashMovement = RecurringCashMovement & {
  payable_note?: string | null;
  start_date?: string;
  end_date?: string | null;
  installments_total?: number | null;
  company_id?: number;
  created_at?: string;
  updated_at?: string;
};

const normalizeRecurringCashMovement = (raw: Record<string, unknown>): RecurringCashMovement => {
  const r = raw as unknown as ApiRecurringCashMovement;
  return {
    ...(r as any),
    id: Number((raw as any).id),
    type: 'saida',
    company_id: (r as any).company_id,
    payable_note: (r as any).payable_note ?? null,
    start_date: (r as any).start_date,
    end_date: (r as any).end_date ?? null,
    installments_total: (r as any).installments_total ?? null,
    created_at: (r as any).created_at,
    updated_at: (r as any).updated_at,
  };
};

const recurringCashMovementService = {
  getAll: async (): Promise<RecurringCashMovement[]> => {
    const response = await api.get('/recurring-cash-movements');
    const list = response.data || [];
    return Array.isArray(list)
      ? list.map((i: Record<string, unknown>) => normalizeRecurringCashMovement(i))
      : [];
  },

  get: async (id: number): Promise<RecurringCashMovement> => {
    const response = await api.get(`/recurring-cash-movements/${id}`);
    return normalizeRecurringCashMovement(response.data as Record<string, unknown>);
  },

  create: async (data: Partial<RecurringCashMovement>): Promise<RecurringCashMovement> => {
    const response = await api.post('/recurring-cash-movements', data);
    return normalizeRecurringCashMovement(response.data as Record<string, unknown>);
  },

  update: async (id: number, data: Partial<RecurringCashMovement>): Promise<RecurringCashMovement> => {
    const response = await api.put(`/recurring-cash-movements/${id}`, data);
    return normalizeRecurringCashMovement(response.data as Record<string, unknown>);
  },

  delete: async (id: number): Promise<number> => {
    const response = await api.delete(`/recurring-cash-movements/${id}`);
    return response.status;
  },
};

export default recurringCashMovementService;

